import { useEffect, useState } from 'react';
import { scrollToHash, clearHash } from '../../utils/ScrollUtil';
import PostCard from './PostCard';
import Pagination from '../pagination/Pagination';
import RequestUtil from '../../utils/APIRequestUtil';
import { Box, Flex, Skeleton } from '@radix-ui/themes';

export default function PostCardList({ sort, keyword, showPinned }) {
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(0);
    const [total, setTotal] = useState(0);
    const [posts, setPosts] = useState([]);
    const [dataReady, setDataReady] = useState(false);

    const fetchData = async (sortType, keyword, pageNo) => {
        const resp = await RequestUtil.get(`/api/posts?sort=${sortType}&keyword=${keyword}&page=${pageNo}`);
        const respBody = await resp.json();
        setDataReady(true);
        setPageSize(respBody.pageSize);
        setTotal(respBody.total);
        setPosts(respBody.results);
        scrollToHash();
    };

    useEffect(() => {
        fetchData(sort, keyword, pageNo);
    }, [sort, keyword, pageNo]);

    const setCurrectPage = (pageNo) => {
        setPageNo(pageNo);
        clearHash();
        document.getElementById('latest-articles')?.scrollIntoView();
    };

    if (!dataReady) {
        return (
            <Flex direction="column" gap="3">
                {Array.from({ length: 6 }).map((_, i) => (
                    <Skeleton key={i} height="100px" />
                ))}
            </Flex>
        );
    }

    return (
        <Box>
            <Flex direction="column" gap="3" id="latest-articles">
                {posts.map((post, index) => (
                    <PostCard
                        key={index}
                        showPinned={showPinned}
                        pinned={post.pinned}
                        blogDomainName={post.blogDomainName}
                        blogName={post.blogName}
                        blogStatusOk={post.blogStatusOk}
                        blogAdminMediumImageURL={post.blogAdminMediumImageURL}
                        link={post.link}
                        title={post.title}
                        description={post.description}
                        publishedAt={post.publishedAt}
                        linkAccessCount={post.linkAccessCount}
                    />
                ))}
            </Flex>

            <Pagination
                pageNo={pageNo}
                pageSize={pageSize}
                total={total}
                setCurrectPage={setCurrectPage}
            />
        </Box>
    );
}
